<template>
  <div class="path-view pa-3">
    <div class="breadcrumbs my-3">
      <div class="breadcrumb active" @click="clickPath(-1)">
        <a>All</a>
        <div class="mx-3" v-if="path.length > 0">/</div>
      </div>
      <div
        class="breadcrumb active"
        v-for="(value, index) in path"
        :key="value"
        @click="clickPath(index)"
      >
        <a>{{value}}</a>
        <div class="mx-3" v-if="index != path.length - 1">/</div>
      </div>
    </div>
    <v-row no-gutters>
      <v-col v-for="node in nextNodes" :key="node.value" cols="12" md="4" xl="3" class="pa-3">
        <div class="aspect-container aspect-container-1-1">
          <div class="aspect-content">
            <div class="tile" @click="select(node)">
              <div class="tile-image-container">
                <img class="tile-image" :src="node.image.smallUrl" />
              </div>
              <div class="tile-text-container">
                <div class="tile-text">{{node.value}}</div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {},
  created: function() {
    if (!this.currentNode.next) {
      this.$router.push(
        `/Manufacturers/${this.$route.params.manufacturerId}/Avenue/Catalog`
      );
    }
    this.$store.commit("setSearch", "");
    this.$store.commit("clearColumnIdToValues");
  },
  data: function() {
    return {};
  },
  computed: {
    config: function() {
      return this.$store.state.config;
    },
    path: function() {
      return this.$store.state.path;
    },
    items: function() {
      return this.config.tileColumns.map((name, index) => {
        return {
          disabled: false,
          text: this.path[index] || name,
          to: `/Manufacturers/${this.$store.state.manufacturerId}/Avenue/Path`
        };
      });
    },
    tree: function() {
      return this.$store.state.tree;
    },
    currentNode: function() {
      return this.$store.getters.currentNode;
    },
    nextNodes: function() {
      return Object.keys(this.currentNode.next).map(
        key => this.currentNode.next[key]
      );
    }
  },
  methods: {
    clickPath(index) {
      this.$store.commit("setPath", index);
      this.$router.push(
        `/Manufacturers/${this.$route.params.manufacturerId}/Avenue/Path`
      );
    },
    select: function(node) {
      this.$store.commit("addToPath", node.value);

      if (!this.currentNode.next) {
        this.$router.push(
          `/Manufacturers/${this.$route.params.manufacturerId}/Avenue/Catalog`
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.value {
  background-color: white;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  border: 1px solid black;

  .img-container {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }

  .name {
    flex: none;
    height: 50px;
    font-weight: bold;
    font-size: 18px;
  }
}

.breadcrumbs {
  display: flex;
  justify-content: center;
  align-items: center;
  //text-transform: uppercase;

  .breadcrumb {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}

.path-view {
  width: 100%;
  height: 100%;
}

.values {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  .value {
    margin: 10px;
  }
}
</style>
